/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Social_Media_Url_LabelInputs */

const en_company_profile_social_media_url_label = /** @type {(inputs: Company_Profile_Social_Media_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile URL or name`)
};

const de_company_profile_social_media_url_label = /** @type {(inputs: Company_Profile_Social_Media_Url_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil-URL oder Name`)
};

/**
* | output |
* | --- |
* | "Profile URL or name" |
*
* @param {Company_Profile_Social_Media_Url_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_social_media_url_label = /** @type {((inputs?: Company_Profile_Social_Media_Url_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Social_Media_Url_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_social_media_url_label(inputs)
	return en_company_profile_social_media_url_label(inputs)
});